import router from 'next/router'

const patchedMethods = new Set()

let hashChanging = false

const onHashChangeStart = () => {
	hashChanging = true
}

const onHashChangeEnd = () => {
	hashChanging = false
}

router.events.on('hashChangeStart', onHashChangeStart)
router.events.on('routeChangeError', onHashChangeEnd)
router.events.on('hashChangeComplete', onHashChangeEnd)

const patchHistoryMethod = (methodName) => {
	if (globalThis.history?.[methodName]) {
		if (!patchedMethods.has(methodName)) {
			const originalHistoryMethod = globalThis.history[methodName]
			globalThis.history[methodName] = (state, ...args) => {
				const { as, options: { shallow, silent } = {} } = state || {}
				const previousState = { ...globalThis.history.state }
				const { as: previousAs, options: previousOptions } = previousState

				const result = originalHistoryMethod.call(globalThis.history, state, ...args)

				if (!silent) {
					router.events.emit(
						hashChanging ? 'bh_afterHashChange' : 'bh_afterHistoryChange',
						as,
						{ shallow },
						previousAs,
						previousOptions
					)
				}

				return result
			}
			patchedMethods.add(methodName)
		}
	}
}

/**
 * This function is used to patch history.pushState and history.replaceState methods.
 * bh_afterHistoryChange event is emitted on next/router after history.pushState and history.replaceState
 */
const nextRouterHistoryProxy = () => {
	patchHistoryMethod('pushState')
	patchHistoryMethod('replaceState')
}

export default nextRouterHistoryProxy
